/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';

// Elements
import '../elements/answer-option/css/answer-option';
import '../elements/progress-bar/css/progress-bar';
import '../elements/question/css/question';
import '../elements/quiz-header/css/quiz-header.scss';
import '../elements/summary/css/summary';
import '../elements/solution-content/css/solution-content.scss';

import './quiz.scss';
